"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Statistics = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const narwhal_1 = require("@centralwebteam/narwhal");
const styled_components_1 = require("../styled-components");
const __1 = require("../");
/** A display oi the process capability statistics Pp, Ppk and StD */
const Statistics = ({ deviations, upperTolerance, lowerTolerance, }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const { pp, ppk, standardDeviation } = narwhal_1.processCapability.getProcessCapability(deviations, upperTolerance, lowerTolerance);
    const clamp = (n) => {
        if (n == undefined)
            return __1.emptyStateText;
        if (n > 10)
            return ">10";
        if (n < 0)
            return "<0";
        return n;
    };
    return (react_1.default.createElement(Footer, null,
        react_1.default.createElement(FooterSection, null,
            t("label-Pp") + ":",
            react_1.default.createElement(__1.NumericValue, { value: clamp(pp), title: pp, name: t("label-Pp"), dp: 2 }),
            react_1.default.createElement(__1.InfoButton, { title: t("label-Pp"), content: t("message-Pp") })),
        react_1.default.createElement(__1.Separator, { noSpace: true }),
        react_1.default.createElement(FooterSection, null,
            t("label-Ppk") + ":",
            react_1.default.createElement(__1.NumericValue, { value: clamp(ppk), title: ppk, name: t("label-Ppk"), dp: 2 }),
            react_1.default.createElement(__1.InfoButton, { title: t("label-Ppk"), content: t("message-Ppk") })),
        react_1.default.createElement(__1.Separator, { noSpace: true }),
        react_1.default.createElement(FooterSection, null,
            t("label-StD") + ":",
            react_1.default.createElement(__1.NumericValue, { value: clamp(standardDeviation), title: standardDeviation, name: t("label-StD"), dp: 4 }),
            react_1.default.createElement(__1.InfoButton, { title: t("label-StD"), content: t("message-StD") }))));
};
exports.Statistics = Statistics;
const Footer = styled_components_1.styled.footer `
  background: ${({ theme }) => theme.inputBg};
  display: grid;
  grid-template-columns: 1fr 1px 1fr 1px 1fr;
  justify-items: center;
`;
const FooterSection = styled_components_1.styled.section `
  padding: 5px 10px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  grid-gap: 1ex;
  align-items: center;
  div {
    visibility: hidden;
  }
  &:hover div {
    visibility: visible;
  }
`;
//# sourceMappingURL=Statistics.js.map